import React from 'react';
import {useSelector} from 'react-redux';

import domClassNames from '../../consts/domClassNames';
import {selectIsPWA} from '../../state/selectors/global';
import {twx} from '../../utils/tailwindUtils';
import uaUtils from '../../utils/uaUtils';

const AppContainer = ({children}) => {
    const isPWA = useSelector(selectIsPWA);
    const isIOSSafari26_1 = uaUtils.checkIsIOSSafari26_1();
    const isIOSSafari27 = uaUtils.checkIsIOSSafari27();

    return (
        <div
            className={twx(
                domClassNames.APP_CONTAINER_CLASSNAME,
                'relative flex w-full flex-col overflow-hidden text-color-primary dark:text-color-romance',
                isPWA && !isIOSSafari26_1 ? 'min-h-lvh' : 'min-h-dvh' // Details in the useIOSSafariFixes hook
            )}
        >
            {isPWA && isIOSSafari27 && (
                // iOS 27 skips its top blur over a solid fixed box (>10px) at the top edge, once black-translucent
                // is gone (useIOSSafariFixes). bg-clip-text hides the strip; WebKit reads the color from style.
                <div className='pointer-events-none fixed inset-x-0 top-0 z-[9999] h-3 bg-color-secondary bg-clip-text dark:bg-color-dark-gray' />
            )}
            {children}
        </div>
    );
};

export default AppContainer;
